import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'
import { useCurrentFolderStore } from './stores/useCurrentFolderStore'
import { ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'

export const useCurrentWorkspaceIdWithProject = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const { currentFolder } = useCurrentFolderStore()

  return currentWorkspaceId !== ALMANAC_CORE_WORKSPACE_ID ? currentWorkspaceId : currentFolder?.real_workspace_id
}
